import { Component } from '@angular/core';
import { Events } from 'ionic-angular';

import { Api } from '../../providers/api/api';
import { IPTV } from '../../providers/iptv/iptv';
import { Utils } from '../../providers/utils/utils';
import { User } from '../../providers/user/user';
import { Gateway } from '../../providers/gateway/gateway';

/*
*
*  Settings Page
* 
*/
@Component({
	selector: 'settings',
  	templateUrl: 'settings.html'
})
export class Settings {

    public interval : any = null;
    public gatewayRestarting : boolean = false;
    public states : any = {
        state  : {},
        state2 : {},
        state3 : {}
    };
    public boxs : any = [];

    constructor(
        public events: Events,
        public IPTV: IPTV,
        public utils: Utils,
        public api: Api,
        public user: User,
        public gateway: Gateway
    ) {

        this.boxs = JSON.parse(JSON.stringify(this.IPTV.boxs))
        this.fetchTroubleshooting();

        if (this.interval) clearInterval(this.interval);

        this.interval = setInterval(() => { 
            if (this.user.isLogged()) this.fetchTroubleshooting(true);
        }, 60000);

        this.events.subscribe('settings:closed', (params : any = {}) => { 
            if (this.interval) clearInterval(this.interval);
        });

  	}

    // Init Troubleshooting
    fetchTroubleshooting(noLoad:boolean=false) {

        if (this.IPTV.contract.parc.has_sup != '1') return false;

        if (!noLoad) {
            this.states.state = { load:true };
            this.states.state2 = { load:true };
            this.states.state3 = { load:true };
            for(let box of this.boxs) {
                box.state = { load:true };
            }
        } else {

        }

        let that = this;

        this.troubleshoot({
            title    : this.IPTV.contract.parc.sup_mnemonic1,
            int      : this.IPTV.contract.parc.sup_number1,
            user     : this.user.data.mail
        }, function(state) { that.states.state = state });

        this.troubleshoot({
            title    : this.IPTV.contract.parc.sup_mnemonic2,
            int      : this.IPTV.contract.parc.sup_number2,
            user     : this.user.data.mail
        }, function(state) { that.states.state2 = state });

        this.troubleshoot({
            title     : this.IPTV.contract.parc.sup_mnemonic3,
            int       : this.IPTV.contract.parc.sup_number3,
            user      : this.user.data.mail
        }, function(state) { that.states.state3 = state });

        for(let box of this.boxs) {
            this.troubleshoot({
                title      : 'SOURCE',
                int        : box.sup_source,
                user       : that.user.data.mail
            }, function(state) { box.state = state });
        }
    }

    troubleshoot(params, callback) {

        if (!params.title) return false;
        
        var state: any = {};

        this.api.get('iptvscripts/hardware', params).subscribe((response:any)=>{
            state.load = false;

            if (parseInt(response.result.code) == 0) {
                state.icon  = 'checkmark-circle';
                state.color = 'success';
            } else if (parseInt(response.result.code) == 2) {
                state.icon  = 'close-circle';
                state.color = 'danger';
            } else {
                state.icon  = 'checkmark-circle';
                state.color = 'grey';
            }
            
            callback(state);
        }, (err) => {

        });
    }

    // Restart a box
    restart(box) {
        let that       = this;
        this.utils.confirm({message: 'Restart '+box.name+' ?'}, function() {

            box.state.load = true;

            that.api.put('iptvscripts/hardware', {
                apc_ip    : box.apc_ip,
                apc_port  : box.apcport,
                encoderIp : that.IPTV.encoder.ip_address,
                user      : that.user.data.mail
            }).subscribe((response:any)=>{

                setTimeout(() => {
                    that.troubleshoot({
                        title      : 'SOURCE',
                        int        : box.sup_source,
                        user       : that.user.data.mail
                    }, function(state) { box.state = state });
                }, 3000);
                
            },(err) => {
                setTimeout(() => {
                    that.troubleshoot({
                        title      : 'SOURCE',
                        int        : box.sup_source,
                        user       : that.user.data.mail
                    }, function(state) { box.state = state });
                }, 3000);
            });
        });
    }

    // restartSup3
    restartSup3(label)
    {
        let that       = this;
        this.utils.confirm({message: 'Restart '+label+' ?'}, function() {

            that.states.state3.load = true;

            that.api.put('iptvscripts/reset', {
                channelName    : that.IPTV.box.beamtv_name,
                user           : that.user.data.mail
            }).subscribe((response:any)=>{
                that.states.state3.load = false;
            },(err) => {
                that.states.state3.load = false;
            });
        });
    }

    // gateway.restart()
    gatewayRestart() {
        this.gateway.restart(true);
        let that = this;
        that.gatewayRestarting = true;
        setTimeout(function() {
            that.gatewayRestarting = false;
        },2000);
    }
    

}


// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts